import React, { useState, useEffect } from "react";
import { Formik, Form, Field, FieldArray, FastField,useFormik } from "formik";
import { MdOutlineRemoveCircle } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import {getAuthorization} from "../../../axios/AxiosAut";
import Swal from "sweetalert2";
import "animate.css";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAPIDetailsSupplierTable } from "../../../redux/slices/statistics/statisticSlice";
import Select from "react-select";
import csc from "country-state-city";

function EditSupplier() {
  const location = useLocation();
  const { state } = location;
  const ID = state;
  const Navigate = useNavigate();
  const [SupplierContacts, setSupplierContacts] = useState();
  const [SupplierDetails, setSupplierDetails] = useState({
    name: "",
    post_code: "",
    city: {name:""},
    email: "",
    country: "",
    state:"",
    street_name: "",
    door_number: "",
    website: "",
    phone_number: "",
    contact: [
      {
        id: "",
        name: "",
        job_role: "",
        phone_number: "",
        email: "",
      },
    ],
  });


  useEffect(() => {
    //Get details of a supplier
    getAuthorization()
      .get(`company/get_supplier/${ID}`)
      .then((res) => {
        setSupplierDetails(res.data);
        setSupplierContacts(res.data.contact);
      })
      .catch((err) => {
        console.log("Error in getting Supplier details", err);
      });
  }, []);

  const dispatch = useDispatch();
  const getSupplierData=()=>{
    getAuthorization()
    .get("company/all_suppliers/")
    .then((res) => {
      // setCompanySuppliers(res.data);
      dispatch(setAPIDetailsSupplierTable(res.data));

    })
    .catch((err) => {
      console.log("Error in getting customers", err);
    });
  }

  const initialValues = {
    name: SupplierDetails?.name,
    post_code: SupplierDetails?.post_code,
    street_name: SupplierDetails?.street_name,
    door_number: SupplierDetails?.door_number,
    country: SupplierDetails?.country,
    state: SupplierDetails?.state,
    city: SupplierDetails?.city.name,
    phone_number: SupplierDetails?.phone_number,
    email: SupplierDetails?.email,
    website: SupplierDetails?.website,
    contact: SupplierContacts===undefined? ([]):(SupplierContacts),
  };

  console.log("SupplierContacts", SupplierContacts)
  const addressFromik = useFormik({
    initialValues: {
      country: SupplierDetails?.country,
      state: SupplierDetails?.state,
      city: SupplierDetails?.city.name,
    },
    onSubmit: (values) => console.log(JSON.stringify(values.country)),
  });

  const countries = csc.getAllCountries();


  const updatedCountries = countries.map((country) => ({
    label: country.name,
    value: country.isoCode,
    ...country,
  }));
  const updatedStates = (countryId) =>
    csc.getStatesOfCountry(countryId).map((state) => ({
      label: state.name,
      value: state.countryCode,
      ...state,
    }));

  const updatedCities = (countryId) =>
    csc.getCitiesOfCountry(countryId).map((city) => ({
      label: city.name,
      value: city.stateCode,
      // lat: city.latitude,
      // long: city.longitude,
      ...city,
    }));

  const [Country,setCountry]=useState<any>({});
  const [State,setState]=useState<any>({});
  const [City,setCity]=useState<any>({});

  const { values, handleSubmit, setFieldValue, setValues } = addressFromik;
  useEffect(() => {}, [values]);
  const Permissions = useSelector((state) => state.user.userPermissions);
  const changesuppliercontacts = Permissions.find((o) => o.codename === "change_suppliercontact");

  const onSubmit = (values, onSubmitProps) => {
    console.log("Supplier", values);
    const payload={
      name: values.name,
      post_code: values.post_code,
      street_name: values.street_name,
      door_number: values.door_number,
      country: Country?.label,
      state: State?.label,
      city: City,
      phone_number: values.phone_number,
      email: values.email,
      website: values.website,
      contact: values.contact===undefined? ([]):(values.contact),
      
    }
    getAuthorization()
      .put(`company/edit_supplier?id=${ID}`, payload)
      .then((res) => {
        onSubmitProps.setSubmitting(false);
        Swal.fire({
          position: "top-end",
          title: "Supplier Edited!",
          showConfirmButton: false,
          timer: 3500,
          showClass: {
            popup: "animate__animated animate__fadeInRight",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutRight",
          },
          width: 300,
          color: "#FFFFFF",
          background: "#2A91D7",
          backdrop: `rgba(0,0,0,0)`,
        });
        getSupplierData();
        Navigate("/dashboard/management/supplier-dashboard");
      })
      .catch((err) => {
        onSubmitProps.setSubmitting(false);
        console.log("Error", err);
      });
  };
  const RemoveTemplateHandler = (remove, index) => {
    remove(index);
  };
  const AddTemplateHandler = (push) => {
    push({
      name: "",
      job_role: "",
      phone_number: "",
      email: "",
    });
  };
  return (
    <>
      <div className="flex flex-col justify-items-center ml-8">
        <h2 className="font-Montserrat text-xl font-bold text-black">
         Edit Supplier
        </h2>
        <div className="border-b-2 border-blue-200 w-24"></div>

        <Formik
          enableReinitialize
          initialValues={initialValues}
          onSubmit={onSubmit}
          //   validationSchema={validationSchema}
          //   validateOnMount
        >
          <Form>
            <div className="mt-9 grid space-y-10">
              <Field name="name">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                      <input
                        {...field}
                        type="text"
                        {...(meta.touched && meta.error
                          ? {
                              className:
                                "border-b-2 bg-default relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                            }
                          : {
                              className:
                                "border-b-2 bg-default relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                            })}
                        placeholder="Name"
                      ></input>
                      {meta.touched && meta.error ? (
                        <label className="text-xs font-semibold font-Montserrat text-red-500">
                          <span className="ml-1">{meta.error}</span>
                        </label>
                      ) : null}
                    </>
                  );
                }}
              </Field>
              <div className="flex w-3/4 flex-row justify-between space-x-5">
                <Field name="phone_number">
                  {(props) => {
                    const { field, form, meta } = props;
                    return (
                      <>
                        <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2 bg-default relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2 bg-default relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="Contact Number"
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </>
                    );
                  }}
                </Field>
                <Field name="email">
                  {(props) => {
                    const { field, form, meta } = props;
                    return (
                      <>
                        <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2 bg-default relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2 bg-default relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="Email"
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </>
                    );
                  }}
                </Field>
              </div>
              <Field name="street_name">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                      <input
                        {...field}
                        type="text"
                        {...(meta.touched && meta.error
                          ? {
                              className:
                                "border-b-2 bg-default relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                            }
                          : {
                              className:
                                "border-b-2 bg-default relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                            })}
                        placeholder="Street Name"
                      ></input>
                      {meta.touched && meta.error ? (
                        <label className="text-xs font-semibold font-Montserrat text-red-500">
                          <span className="ml-1">{meta.error}</span>
                        </label>
                      ) : null}
                    </>
                  );
                }}
              </Field>
              <div className="flex w-3/4 flex-row justify-between space-x-5">
                <Field name="door_number">
                  {(props) => {
                    const { field, form, meta } = props;
                    return (
                      <>
                        <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2 bg-default relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2 bg-default relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="Door Number"
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </>
                    );
                  }}
                </Field>
                <Field name="post_code">
                  {(props) => {
                    const { field, form, meta } = props;
                    return (
                      <>
                        <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2 bg-default relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2 bg-default relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="Post Code"
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </>
                    );
                  }}
                </Field>
              </div>
              <div className="flex w-3/4 flex-row justify-between space-x-5">
                <Field name="country">
                  {(props) => {
                    const { field, form, meta } = props;
                    return (
                      <>
                        {/* <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2 bg-default relative block w-2/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2 bg-default relative block w-2/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="Country"
                        ></input> */}
                        <Select
                          {...field}
                          id="country"
                          name="country"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "bg-default relative block w-full  border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  " bg-default relative block w-full  border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          options={updatedCountries}
                          value={values.country}
                          
                          placeholder={SupplierDetails?.country}
                          onChange={(value) => {
                            // setValues(
                            //   { country: value, state: null, city: null },
                            //   false
                            // );
                            setFieldValue("country", value);
                            setCountry(value);
                            console.log("country value", value);
                          }}
                        />
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </>
                    );
                  }}
                </Field>
                
              </div>
              <div className="flex w-3/4 flex-row justify-between space-x-5">
                <Field name="state">
                  {(props) => {
                    const { field, form, meta } = props;
                    return (
                      <>
                        {/* <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2 bg-default relative block w-2/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2 bg-default relative block w-2/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="Country"
                        ></input> */}
                        <Select
                          {...field}
                          id="state"
                          name="state"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "bg-default relative block w-2/4  border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  " bg-default relative block w-2/4  border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                              placeholder={SupplierDetails?.state}
                              options={updatedStates(
                                values.country ? values.country.value : null
                              )}
                              value={values.state}
                              onChange={(value) => {
                                setValues({ state: value, city: null }, false);
                                setState(value)
                              }}
                        />
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </>
                    );
                  }}
                </Field>
                <Field name="city">
                  {(props) => {
                    const { field, form, meta } = props;
                    return (
                      <>
                        {/* <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2 bg-default relative block w-2/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2 bg-default relative block w-2/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="City"
                        ></input> */}
                        <Select
                          {...field}
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  " bg-default relative block w-2/4  border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  " bg-default relative block w-2/4  border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          id="city"
                          name="city"
                          placeholder={SupplierDetails?.city.name}
                          options={updatedCities(
                            values.state ? values.state.value : null
                          )}
                          value={values.city}
                          onChange={(value) => {setFieldValue("city", value); setCity(value)}}
                        />
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </>
                    );
                  }}
                </Field>
              </div>
              <Field name="website">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                      <input
                        {...field}
                        type="text"
                        {...(meta.touched && meta.error
                          ? {
                              className:
                                "border-b-2 bg-default relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                            }
                          : {
                              className:
                                "border-b-2 bg-default relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                            })}
                        placeholder="Website"
                      ></input>
                      {meta.touched && meta.error ? (
                        <label className="text-xs font-semibold font-Montserrat text-red-500">
                          <span className="ml-1">{meta.error}</span>
                        </label>
                      ) : null}
                    </>
                  );
                }}
              </Field>
              {!changesuppliercontacts ===undefined ||  changesuppliercontacts?.codename ===
              "change_suppliercontact" ? (
              <FieldArray name="contact">
                {(FieldArrayProps) => {
                  const { push, remove, form } = FieldArrayProps;
                  const { values } = form;
                  const { contact } = values;
                  return (
                    <>
                      <div className="flex flex-row mt-3 space-x-2">
                        <button
                          type="button"
                          onClick={() => AddTemplateHandler(push)}
                        >
                          <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle
                              cx="12.5"
                              cy="12.5"
                              r="12.5"
                              fill="#1F78B4"
                            />
                            <path
                              d="M6.66406 12.5013H18.3307M12.4974 6.66797V12.5013V18.3346"
                              stroke="white"
                              stroke-width="1.66667"
                            />
                          </svg>
                        </button>
                        <p className="text-blue-200">Add Contacts</p>
                      </div>
                      {contact.map((contact, index) => (
                        <>
                          {/* <div className="flex flex-col"> */}
                          <div className="flex w-3/4 flex-row justify-between space-x-5">
                            <FastField name={`contact.${[index]}.name`}>
                              {(props) => {
                                const { field, form, meta } = props;
                                return (
                                  <>
                                    <input
                                      {...field}
                                      {...(meta.touched && meta.error
                                        ? {
                                            className:
                                              "border-b-2 bg-default relative block w-2/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                          }
                                        : {
                                            className:
                                              "border-b-2 bg-default relative block w-2/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                          })}
                                      type="text"
                                      id="name"
                                      placeholder="Name"
                                      value={
                                        values.contact[index].name === null ||
                                        values.contact[index].name ===
                                          undefined
                                          ? ""
                                          : values.contact[index].name
                                      }
                                    ></input>
                                    {meta.touched && meta.error ? (
                                      <label className="text-xs font-semibold font-Montserrat text-red-500">
                                        <span className="ml-1">
                                          {meta.error}
                                        </span>
                                      </label>
                                    ) : null}
                                  </>
                                );
                              }}
                            </FastField>
                            <FastField name={`contact.${[index]}.job_role`}>
                              {(props) => {
                                const { field, form, meta } = props;
                                return (
                                  <>
                                    <input
                                      {...field}
                                      {...(meta.touched && meta.error
                                        ? {
                                            className:
                                              "border-b-2 bg-default relative block w-2/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                          }
                                        : {
                                            className:
                                              "border-b-2 bg-default relative block w-2/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                          })}
                                      type="text"
                                      id="job_role"
                                      placeholder="Job Role"
                                      value={
                                        values.contact[index].job_role ===
                                          null ||
                                        values.contact[index].job_role ===
                                          undefined
                                          ? ""
                                          : values.contact[index].job_role
                                      }
                                    ></input>
                                    {meta.touched && meta.error ? (
                                      <label className="text-xs font-semibold font-Montserrat text-red-500">
                                        <span className="ml-1">
                                          {meta.error}
                                        </span>
                                      </label>
                                    ) : null}
                                  </>
                                );
                              }}
                            </FastField>
                          </div>
                          <div className="flex w-3/4 flex-row justify-between space-x-5">
                            <FastField
                              name={`contact.${[index]}.phone_number`}
                            >
                              {(props) => {
                                const { field, form, meta } = props;
                                return (
                                  <>
                                    <input
                                      {...field}
                                      {...(meta.touched && meta.error
                                        ? {
                                            className:
                                              "border-b-2 bg-default relative block w-2/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                          }
                                        : {
                                            className:
                                              "border-b-2 bg-default relative block w-2/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                          })}
                                      type="text"
                                      id="phone_number"
                                      placeholder="Phone Number"
                                      value={
                                        values.contact[index].phone_number ===
                                          null ||
                                        values.contact[index].phone_number ===
                                          undefined
                                          ? ""
                                          : values.contact[index].phone_number
                                      }
                                    ></input>
                                  </>
                                );
                              }}
                            </FastField>
                            <FastField name={`contact.${[index]}.email`}>
                              {(props) => {
                                const { field, form, meta } = props;
                                return (
                                  <>
                                    <input
                                      {...field}
                                      {...(meta.touched && meta.error
                                        ? {
                                            className:
                                              "border-b-2 bg-default relative block w-2/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                          }
                                        : {
                                            className:
                                              "border-b-2 bg-default relative block w-2/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                          })}
                                      type="text"
                                      id="email"
                                      placeholder="Email"
                                      value={
                                        values.contact[index].email === null ||
                                        values.contact[index].email ===
                                          undefined
                                          ? ""
                                          : values.contact[index].email
                                      }
                                    ></input>
                                    {meta.touched && meta.error ? (
                                      <label className="text-xs font-semibold font-Montserrat text-red-500">
                                        <span className="ml-1">
                                          {meta.error}
                                        </span>
                                      </label>
                                    ) : null}
                                  </>
                                );
                              }}
                            </FastField>
                          </div>
                          <div className="flex flex-row mt-3 space-x-2">
                            <button
                              type="button"
                              onClick={() =>
                                RemoveTemplateHandler(remove, index)
                              }
                            >
                              <MdOutlineRemoveCircle
                                size={27}
                                color="#B91C1C"
                              />
                            </button>
                            <p className="text-red-700">Remove Contact</p>
                          </div>
                        </>
                      ))}
                    </>
                  );
                }}
              </FieldArray>
                 ) : null}

            </div>
            <Field name="email">
              {(props) => {
                const { field, form, meta } = props;
                const { isSubmitting } = form;

                return (
                  <>
                    <div className="flex flex-row justify-center space-x-128 my-10">
                      <button
                        className="text-red-600 font-Montserrat font-medium text-lg"
                        onClick={() =>
                          Navigate("/dashboard/management/supplier-dashboard")
                        }
                        type="button"
                      >
                        Go Back
                      </button>

                      {!isSubmitting ? (
                        <button
                          type="submit"
                          className="text-white bg-green-100 hover:bg-green-200 font-Montserrat font-medium text-lg place-content-center rounded-md py-1 px-16 flex flex-shrink-1 "
                        >
                          Save
                        </button>
                      ) : (
                        <button
                          disabled
                          className="text-white bg-green-100 hover:bg-green-200 font-Montserrat font-medium text-lg place-content-center rounded-md py-1 px-16 flex flex-shrink-1 "
                        >
                          <div className="flex items-center justify-center space-x-2 animate-pulse">
                            <svg className="w-5 h-5 bg-green-50 rounded-full"></svg>
                            <svg className="w-5 h-5 bg-green-50  rounded-full"></svg>
                            <svg className="w-5 h-5 bg-green-50  rounded-full"></svg>
                          </div>
                        </button>
                      )}
                    </div>
                  </>
                );
              }}
            </Field>
          </Form>
        </Formik>
      </div>
    </>
  );
}

export default EditSupplier;
